import { render, staticRenderFns } from "./HoldingSummary.vue?vue&type=template&id=38cc346c&"
import script from "./HoldingSummary.vue?vue&type=script&lang=js&"
export * from "./HoldingSummary.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src1477836768/src/github.com/FebosIO/Febos-AMI/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('38cc346c')) {
      api.createRecord('38cc346c', component.options)
    } else {
      api.reload('38cc346c', component.options)
    }
    module.hot.accept("./HoldingSummary.vue?vue&type=template&id=38cc346c&", function () {
      api.rerender('38cc346c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/febos/global/operations/components/transactionality/HoldingSummary.vue"
export default component.exports